module.exports = __webpack_public_path__ + "static/7-de74dbb27ab134991ea971c8f07e317e.png";